<template>
  <div>
    <module-card title="筛选">
      <el-form :inline="true" :model="searchForm">
        <el-form-item label="活动名称">
          <el-autocomplete
          v-model="searchForm.name"
          :fetch-suggestions="querySearch"
          placeholder="请输入活动名称"
          :trigger-on-focus="false"
          value-key="name"
          clearable
          style="width: 202px">
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="活动类型">
          <el-select clearable v-model="searchForm.type">
            <el-option label="全部" value="" hidden></el-option>
            <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开卡服务">
          <el-select clearable v-model="searchForm.subType">
            <el-option label="全部" value="" hidden></el-option>
            <el-option v-for="item in subTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动地区">
          <address-select ref="addressForm" v-model="searchForm.activityAddress" :value="searchForm.activityAddress" :show-area="false" @getValue="getAddress" :required="false"></address-select>
        </el-form-item>
        <el-form-item label="报名状态" v-if="![0, 1, 9].includes(this.$store.state.userInfo.userType)">
          <el-select  v-model="searchForm.isSignUp" clearable>
            <el-option label="全部" value="" hidden></el-option>
            <el-option label="已报名" :value="0"></el-option>
            <el-option label="未报名" :value="1"></el-option>
            <el-option label="报名中" :value="2"></el-option>
            <el-option label="报名失败" :value="3"></el-option>
            <el-option label="已关闭" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <auth-button opt="search" :loading="searchLoading" @click.native="search" label="查询"></auth-button>
        </el-form-item>
      </el-form>
    </module-card>
    <module-card title="活动报名">
      <div v-if="activityList.length === 0" class="info">暂无推广活动</div>
      <template v-else>
        <el-row>
          <el-col :span="8" v-for="(item, index) in activityList" :key="index">
            <el-card class="activity-item">
              <div slot="header" class="flex-space-between">
                <div class="flex-start">
                  <img class="icon" src="../../assets/image/A.png" v-if="item.activityType === 1" alt="A"/>
                  <img class="icon" src="../../assets/image/B.png" v-if="item.activityType === 2" alt="B"/>
                  <img class="icon" src="../../assets/image/C.png" v-if="item.activityType === 3" alt="C"/>
                  <span class="activity-title">{{item.name}}</span>
                </div>
                <div class="activity-view" type="text" @click="previewFile(item.fileDetails)">
                  <div class="policy">查看政策</div>
                  <img src="../../assets/image/arrow.png" class="arrow" alt="箭头"/>
                </div>
              </div>
              <div class="activity-body">
                <div class="flex-start-start">
                  <div class="activity-label">活动类型：</div>
                  <div class="activity-value">{{getTypeText(item.type, typeList)}}</div>
                </div>
                <div class="flex-start-start">
                  <div class="activity-label">开卡服务：</div>
                  <div class="activity-value">{{getTypeText(item.subType, subTypeList)}}</div>
                </div>
                <div class="flex-start-start">
                  <div class="activity-label">活动时间：</div>
                  <div class="activity-value">{{`${item.startTime}-${item.endTime}`}}</div>
                </div>
                <div class="flex-start-start">
                  <div class="activity-label">活动地区：</div>
                  <div class="activity-area">{{item.isCountry || !item.address ? '全国' : `${item.address.provinceName}${item.address.cityName.join('，')}`}}</div>
                </div>
                <div class="flex-start-start">
                  <div class="activity-label">活动说明：</div>
                  <div class="activity-desc">{{item.desc || '-'}}</div>
                </div>
              </div>
              <el-row style="padding-top: 18px;height: 60px;" align="middle" type="flex" justify="space-between">
                <el-button type="text" v-if="item.isSignUp === 0 && !fromManager" @click="downloadImage(item)" :loading="downloading && item.code === currentActivity.code" class="link">下载活动推广图</el-button>
                <el-button type="text" v-else-if="fromManager && ![9].includes($store.state.userInfo.userType)" @click="showRecord(item)" class="link">推广记录</el-button>
                <div v-else class="link"></div>
                <!-- 普通运营推广记录，活动报名，商户推送均 无权限/隐藏 -->
                <div class="activity-action" v-if="![1].includes($store.state.userInfo.userType)">
                  <el-button type="primary" round size="mini" v-if="(item.isSignUp !== 0 || fromManager) && item.isSignUp !== 4" @click="signActivity(item)">活动报名</el-button>
                  <div class="mark-btn active" v-else @click="signActivity(item)" :class="{'disabled': item.isSignUp === 4}">
                    <span>{{item.isSignUp === 4 ? '已关闭' : '已报名'}}</span>
                    <div class="mark"><i class="el-icon-check"></i></div>
                  </div>
                  <!-- 联合收单运营只有活动报名按钮权限，其余隐藏 -->
                  <div v-if="![9].includes($store.state.userInfo.userType)" style="margin-left: 20px">
                    <el-button type="primary" round size="mini" v-if="!item.isPush || fromManager" :disabled="item.isSignUp === 4 || (!item.isSignUp && !fromManager)" @click="pushMerchant(item)">商户推送</el-button>
                    <div class="mark-btn active" v-else>
                      <span>已推送</span>
                      <div class="mark"><i class="el-icon-check"></i></div>
                    </div>
                  </div>
                </div>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="btm-action">
            <pagination @changePage="onChangeCurrentPage" :count="pagination.count" :page-no="pagination.pageNo" :size="pagination.pageSize"></pagination>
          </el-col>
        </el-row>
      </template>
    </module-card>
    <dialog-info :visible.sync="showConfirmDialog" :confirmLoading="confirmLoading" @confirm="handleConfirm" class="showConfirm" :dialogWidth="confirmType === 'sign' ? 900 : 700" :class="{'left': confirmType === 'sign'}" :showHeader="true" :showClose="confirmType !== 'sign'">
      <div slot='header' class="flex-space-between">
          <div class="dialog-header">{{ confirmType === 'sign' ? '活动报名' : '商户推送' }}</div>
          <!-- 0是 1未报名 2报名中 3报名失败 -->
          <div v-show="confirmType === 'sign'" class="dialog-status" :class="{ 'success': [2, 0].includes(currentActivity.isSignUp), 'fail': currentActivity.isSignUp === 1}">{{  getSignUpStatus(currentActivity.isSignUp) }}</div>
      </div>
      <div v-show="confirmType === 'sign'" style="padding-bottom: 32px">确定报名此银行活动，请下载协议并盖章上传文件</div>
      <el-form>
        <el-form-item label="展业协议">
          <div class="flex-start-start">
            <!-- <upload-img-ele v-show="confirmType === 'sign'"></upload-img-ele> -->
            <upload-img-ele
              v-show="confirmType === 'sign'"
              ref="agreementImg"
              :clearable="true"
              valueName="agreementImg"
              :value="agreementImg"
              @upload="(data) => agreementImg = data.path"
              :download="true"
              :disabled="[2, 0].includes(currentActivity.isSignUp)"></upload-img-ele>
            <a href="static/联合收单代理商合规展业承诺函.pdf" class="downloadLink" download style="margin-left: 12px">下载协议模板</a>
          </div>
        </el-form-item>
      </el-form>
      <div v-show="confirmType === 'push'">请确认是否推送至与活动银行地区匹配的商户？</div>
      <div v-show="confirmType === 'push'">商户在乐刷《收银通商户版App》及《聚合商户后台》中收到银行活动推送，可<span class="red">自主报名</span>银行活动</div>
    </dialog-info>
    <dialog-info title="报名成功，分享专属推广图" :visible.sync="showShareVisible" :confirmLoading="downloading" @confirm="downloadImage1" class="showConfirm" size="middle" confirmText="下载海报">
      <div class="poster-outer">
        <div class="poster" id="downloadImg">
          <div class="qrcode">
            <div class="img_box" id="img_box"></div>
          </div>
          <img class="poster-bg" :src="extendImage" v-if="extendImage" alt="扫码办卡海报"/>
          <img class="poster-bg" src="@/assets/image/poster.png" alt="扫码办卡海报" v-else>
          <div class="poster-title">{{currentActivity.name}}</div>
          <div class="poster-info">
            活动时间：{{`${currentActivity.startTime}-${currentActivity.endTime}`}}
          </div>
          <div class="flex-start-start poster-info time">
            <div class="poster-label">活动地区：</div>
            <div class="poster-area">{{currentActivity.isCountry || !currentActivity.address ? '全国' : `${currentActivity.address.provinceName}${currentActivity.address.cityName.join('，')}`}}</div>
          </div>
        </div>
      </div>
    </dialog-info>
    <el-dialog
      @close="URL && URL.revokeObjectURL(this.pdfLink)"
      :visible.sync="showPdfVisible"
      width="60%"
      center>
      <embed :src="pdfLink" width="100%" height="600"/>
    </el-dialog>
    <div class="poster outer" id="downloadImg1">
      <div class="qrcode">
        <div class="img_box" id="img_box1"></div>
      </div>
      <img class="poster-bg" :src="extendImage" alt="扫码办卡海报" v-if="extendImage"/>
      <img class="poster-bg" src="@/assets/image/poster.png" alt="扫码办卡海报" v-else>
      <div class="poster-title">{{currentActivity.name}}</div>
      <div class="poster-info">
        活动时间：{{`${currentActivity.startTime}-${currentActivity.endTime}`}}
      </div>
      <div class="flex-start-start poster-info time">
        <div class="poster-label">活动地区：</div>
        <div class="poster-area">{{currentActivity.isCountry || !currentActivity.address ? '全国' : `${currentActivity.address.provinceName}${currentActivity.address.cityName.join('，')}`}}</div>
      </div>
    </div>
    <a ref="downloadLink"></a>
    <dialog-info :title="confirmType === 'sign' ? '活动报名' : '商户推送'" :visible.sync="showBatchDialog" label-width="80px" label-position="left" :dialogWidth="700" footerAlign="center" :confirmLoading="batchLoading" @confirm="handleBatchConfirm" @close="batchForm.agentIds = ''">
      <div v-if="confirmType === 'push'" style="margin-bottom: 24px">商户在乐刷《收银通商户版App》及《聚合商户后台》中收到银行活动推送，可<span class="red">自主报名</span>银行活动</div>
      <el-form :model="batchForm" ref="batchForm" :rules="ruleData">
        <el-form-item label="代理商编号" prop="agentIds">
          <el-input v-model="batchForm.agentIds" :placeholder="batchPlaceholder" type="textarea" style="width: 80%" :autosize="{ minRows: 3, maxRows: 5}" resize="none"></el-input>
        </el-form-item>
      </el-form>
    </dialog-info>
    <dialog-info :title="confirmType === 'sign' ? '报名结果' : '推送结果'" :visible.sync="showBatchResultDialog" :showCancelBtn="false" :showConfirmBtn="false" class="addResult">
      <p class="add-info">已成功添加{{successNum}}个代理商，以下{{failNum}}个代理商添加失败<span v-show="failNum > 10">（最多展示10个，更多可<a @click="jumpDownload" class="downloadLink">下载失败详情文件</a>）</span></p>
      <el-table class="table" border :data="failAgents">
        <el-table-column
          label="代理商编号"
          prop="agentId">
        </el-table-column>
        <el-table-column
          label="失败原因"
          prop="errorMsg">
        </el-table-column>
      </el-table>
    </dialog-info>
    <dialog-info title="查看操作记录" :visible.sync="showRecordDialog" :showConfirmBtn="false" :showCancelBtn="false" :dialogWidth="700">
      <el-table border :data="extensionRecord" v-loading="recordLoading">
        <el-table-column
          prop="operationTime"
          label="操作时间"
          width="160"></el-table-column>
        <el-table-column
          prop="operationType"
          label="操作"
          width="100">
          <template slot-scope="scope">
            {{scope.row.operationType == 1 ? '报名' : '推送'}}
          </template>
        </el-table-column>
        <el-table-column
          prop="agentId"
          label="代理商编号"></el-table-column>
        <el-table-column
          prop="operatorName"
          label="操作人"
          width="130"></el-table-column>
      </el-table>
      <pagination
        :count="recordPagination.total"
        :page-no="recordPagination.pageNo"
        :size="recordPagination.pageSize"
        @changePage="value => { recordPagination.pageNo = value;getRecordList() }"
        @changeSize="value => { recordPagination.pageSize = value;recordPagination.pageNo = 1;getRecordList() }"
      ></pagination>
    </dialog-info>
  </div>
</template>

<script>
// activityBatchSign, activityBatchPush
import QRCode from 'qrcodejs2'
import html2canvas from 'html2canvas'
import pagination from '@/components/pagination'
import dialogInfo from '@/components/layout/dialogInfo'
import { getH5Domain } from '@/assets/js/utils'
import '@/assets/css/resolve.less'
import uploadImgEle from '@/components/upload/uploadImgEle'
import addressSelect from '@/components/addressSelect'

export default {
  name: 'activitySign',
  components: {
    addressSelect,
    pagination,
    dialogInfo,
    uploadImgEle
  },
  data () {
    return {
      pagination: {
        pageNo: 1,
        count: 0,
        pageSize: 9
      },
      activityList: [],
      typeList: [
        {
          value: 10,
          label: '月返'
        },
        {
          value: 20,
          label: '实时返'
        },
        {
          value: 30,
          label: '实时返非0费率'
        }
      ],
      currentActivity: {},
      showConfirmDialog: false,
      confirmLoading: false,
      confirmType: 'sign', // sign: 报名 push: 推送
      showPdfVisible: false,
      showShareVisible: false,
      qrcode: null,
      downloading: false,
      batchForm: {
        agentIds: ''
      },
      fromManager: [0, 9].includes(this.$store.state.userInfo.userType),
      showBatchDialog: false,
      batchLoading: false,
      ruleData: {
        agentIds: [{
          required: true,
          trigger: 'blur',
          validator: (rule, value, callback) => {
            console.log(value)
            if (!value) {
              callback(new Error('请输入代理商编号'))
            } else if (!/^\d+(,\d+)*,?$/.test(value)) {
              callback(new Error('请输入正确的代理商编号,多个代理商请以英文逗号","隔开'))
            } else {
              callback()
            }
          }
        }]
      },
      failAgents: [],
      successNum: '',
      failNum: '',
      showBatchResultDialog: false,
      extensionRecord: [],
      recordPagination: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      },
      showRecordDialog: false,
      recordLoading: false,
      recordActivityId: '',
      extendImage: '',
      agreementImg: '',
      signUpStatusList: [{
        value: 0,
        label: '报名成功'
      }, {
        value: 1,
        label: ''
      }, {
        value: 2,
        label: '报名中'
      }, {
        value: 3,
        label: '报名失败'
      }],
      searchForm: {
        name: '', // 活动名称
        type: '', // 活动类型
        subType: '', // 开卡服务类型 0不支持开卡，10上门开卡  20邮政工资卡 30网点开卡 40上门/网点开卡
        isSignUp: '', // 是否报名: 0是 1未报名 2报名中 3报名失败
        provinceNo: '',
        cityNo: '',
        activityAddress: {
          provinceNo: '',
          cityNo: ''
        }
      },
      subTypeList: [{
        value: 0,
        label: '不支持开卡'
      }, {
        value: 10,
        label: '上门开卡'
      }, {
        value: 30,
        label: '网点开卡'
      }, {
        value: 40,
        label: '上门/网点开卡'
      }],
      searchLoading: false
    }
  },
  methods: {
    onChangeCurrentPage (value) {
      this.pagination.pageNo = value
      this.getList()
    },
    getTypeText (type, typeList) {
      const result = typeList.filter(item => {
        return item.value === type
      })
      if (result.length === 1) {
        return result[0].label
      } else {
        return '未知'
      }
    },
    getList () {
      this.searchLoading = true
      const params = Object.assign({}, this.pagination, this.searchForm)
      this.$axios.post(this.$api.extensionActivityList, params).then(res => {
        this.searchLoading = false
        if (res.respCode === '0') {
          this.pagination.count = res.data.count
          res.data.list = res.data.list || []
          res.data.list.forEach(item => {
            item.isSignUp = parseInt(item.isSignUp) // 是否报名: 0是 1未报名 2报名中 3报名失败
            item.isPush = item.isPush === 0
            item.startTime = item.startTime.replace(/-/g, '.')
            item.endTime = item.endTime.replace(/-/g, '.')
            item.startTime.length > 10 && (item.startTime = item.startTime.substring(0, 10))
            item.endTime.length > 10 && (item.endTime = item.endTime.substring(0, 10))
          })
          this.activityList = res.data.list
        }
      })
    },
    signActivity (row) {
      if (row.isSignUp === 4) {
        return
      }
      this.confirmType = 'sign'
      this.fromManager ? this.showBatchDialog = true : this.showConfirmDialog = true
      this.currentActivity = row
      console.log('row: ', JSON.stringify(row))
      this.agreementImg = row.agreementImg || ''
    },
    pushMerchant (row) {
      this.confirmType = 'push'
      this.fromManager ? this.showBatchDialog = true : this.showConfirmDialog = true
      this.currentActivity = row
    },
    handleConfirm () {
      this.confirmLoading = true
      if (this.confirmType === 'sign') {
        if ([2, 0].includes(this.currentActivity.isSignUp)) {
          this.confirmLoading = false
          this.showConfirmDialog = false
          return
        }
        if (!this.agreementImg) {
          this.$message({
            message: '请上传展业协议',
            type: 'warning',
            showClose: true
          })
          this.confirmLoading = false
          return
        }
        this.$axios.post(this.$api.activitySign, {
          code: this.currentActivity.code,
          agreementImg: this.agreementImg
        }).then(res => {
          this.confirmLoading = false
          if (res.respCode === '0') {
            this.showConfirmDialog = false
            this.$message({
              message: '报名申请成功',
              type: 'success',
              showClose: true
            })
            // this.showPoster(this.currentActivity)
            this.getList()
          }
        }).catch(() => {
          this.confirmLoading = false
        })
      } else {
        this.confirmLoading = false
        this.$axios.post(this.$api.activityPush, { code: this.currentActivity.code }).then(res => {
          this.showConfirmDialog = false
          if (res.respCode === '0') {
            this.$message({
              message: '推送成功',
              type: 'success',
              showClose: true
            })
            this.getList()
          }
        }).catch(() => {
          this.confirmLoading = false
        })
      }
    },
    previewFile (fileDetails) {
      if (!fileDetails || !fileDetails[0]) {
        this.$message({
          type: 'error',
          message: '当前活动未上传政策文件'
        })
      } else {
        this.$axios.get(this.$api.previewActivity, {
          params: {
            fileId: fileDetails[0].fileId
          },
          responseType: 'blob'
        }).then(res => {
          if ((res && res.respCode) || !res) {
            return
          }
          const blob = new Blob([res], {
            type: 'application/pdf;charset=utf-8'
          })
          this.pdfLink = URL.createObjectURL(blob)
          this.showPdfVisible = true
        })
      }
    },
    showPoster (row) {
      this.currentActivity = row
      this.showShareVisible = true
      this.$nextTick(() => {
        if (this.qrcode !== null) {
          document.getElementById('img_box').innerHTML = ''
        }
        this.qrcode = new QRCode(document.getElementById('img_box'), {
          width: 800, // 设置宽高
          height: 800,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
        this.qrcode.clear()
        this.qrcode.makeCode(`${getH5Domain()}/wap/union-receipt-h5/#/activity-sign?activityId=${row.code}&agentId=${this.$store.state.userInfo.userValue}`)
      })
    },
    async downloadImage (row) {
      await this.getExtensionImg(row.extensionImg)
      console.log('success')
      this.currentActivity = row
      this.downloading = true
      this.$nextTick(() => {
        if (this.qrcode !== null) {
          document.getElementById('img_box1').innerHTML = ''
        }
        this.qrcode = new QRCode(document.getElementById('img_box1'), {
          width: 800, // 设置宽高
          height: 800,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
        this.qrcode.clear()
        this.qrcode.makeCode(`${getH5Domain()}/wap/union-receipt-h5/#/activity-sign?activityId=${row.code}&agentId=${this.$store.state.userInfo.userValue}`)
        this.$nextTick(() => {
          html2canvas(document.getElementById('downloadImg1'), {
            backgroundColor: null, // 背景颜色
            dpi: 192, // 将分辨率提高到特定的dpi,默认值为96
            scale: 2, // 用于渲染的比例尺。默认为浏览器设备像素比率。默认值是1，手机端设置成2
            useCORS: true // 是否尝试使用CORS从服务器加载图像
          }).then((canvas) => {
            this.downloading = false
            this.$refs.downloadLink.href = canvas.toDataURL('image/png')
            this.$refs.downloadLink.download = '活动推广图.png'
            this.$refs.downloadLink.click()
          }).catch((e) => {
            console.log(e)
            this.downloading = false
            this.$message({
              message: '下载失败，请稍后再试',
              type: 'error'
            })
          })
        })
      })
    },
    async downloadImage1 () {
      await this.getExtensionImg(this.currentActivity.extensionImg)
      console.log('success')
      this.downloading = true
      this.$nextTick(() => {
        html2canvas(document.getElementById('downloadImg'), {
          backgroundColor: null, // 背景颜色
          dpi: 192, // 将分辨率提高到特定的dpi,默认值为96
          scale: 2, // 用于渲染的比例尺。默认为浏览器设备像素比率。默认值是1，手机端设置成2
          useCORS: true // 是否尝试使用CORS从服务器加载图像
        }).then((canvas) => {
          this.downloading = false
          this.$refs.downloadLink.href = canvas.toDataURL('image/png')
          this.$refs.downloadLink.download = '活动推广图.png'
          this.$refs.downloadLink.click()
        }).catch((e) => {
          console.log(e)
          this.downloading = false
          this.$message({
            message: '下载失败，请稍后再试',
            type: 'error'
          })
        })
      })
    },
    handleBatchConfirm () {
      this.$refs.batchForm.validate(valid => {
        if (valid) {
          this.batchLoading = true
          if (this.confirmType === 'sign') {
            this.$axios.post(this.$api.activityBatchSign, {
              code: this.currentActivity.code,
              agentIds: this.batchForm.agentIds
            }).then(res => {
              this.batchLoading = false
              if (res.respCode === '0') {
                this.showBatchDialog = false
                if (res.data.failCount === 0) {
                  this.$message({
                    message: '报名成功',
                    type: 'success',
                    showClose: true
                  })
                } else {
                  this.failAgents = res.data.failAgents
                  this.successNum = res.data.successCount
                  this.failNum = res.data.failCount
                  this.showBatchResultDialog = true
                }
                this.getList()
              }
            }).catch(() => {
              this.batchLoading = false
            })
          } else {
            this.$axios.post(this.$api.activityBatchPush, {
              code: this.currentActivity.code,
              agentIds: this.batchForm.agentIds
            }).then(res => {
              this.batchLoading = false
              this.showBatchDialog = false
              if (res.respCode === '0') {
                if (res.data.failCount === 0) {
                  this.$message({
                    message: '推送成功',
                    type: 'success',
                    showClose: true
                  })
                } else {
                  this.failAgents = res.data.failAgents
                  this.successNum = res.data.successCount
                  this.failNum = res.data.failCount
                  this.showBatchResultDialog = true
                }
                this.getList()
              }
            }).catch(() => {
              this.batchLoading = false
            })
          }
        }
      })
    },
    getRecordList () {
      this.recordLoading = true
      this.$axios.post(this.$api.extensionRecord, Object.assign({
        activityId: this.recordActivityId
      }, this.recordPagination)).then(res => {
        this.recordLoading = false
        if (res.respCode === '0') {
          this.recordPagination.total = res.data.count
          this.extensionRecord = res.data.logList || []
        }
      })
    },
    showRecord (item) {
      this.recordActivityId = item.code
      this.recordPagination.pageNo = 1
      this.showRecordDialog = true
      this.getRecordList()
    },
    async getExtensionImg (src) {
      if (src) {
        return new Promise((resolve, reject) => {
          this.$axios.post(this.$api.img2base64, {
            imgPath: src
          }).then(res => {
            if (res.respCode === '0') {
              this.extendImage = 'data:image/png;base64,' + res.data
            }
            resolve()
          }).catch(e => {
            reject(e)
          })
        })
      } else {
        this.extendImage = ''
      }
    },
    jumpDownload () {
      this.showBatchResultDialog = false
      this.$store.dispatch('delVisitedViews', {
        path: '/fileManage/downloadCenter'
      }).then(() => {
        this.$router.push('/fileManage/downloadCenter')
      })
    },
    getSignUpStatus (value) {
      const result = this.signUpStatusList.filter(item => value === item.value)
      if (result.length) {
        return result[0].label
      }
      return '未知'
    },
    search () {
      this.pagination.pageNo = 1
      this.searchLoading = true
      const params = Object.assign({}, this.pagination, this.searchForm)
      this.$axios.post(this.$api.activityExtensionList, params).then(res => {
        this.searchLoading = false
        if (res.respCode === '0') {
          this.pagination.count = res.data.count
          res.data.list = res.data.list || []
          res.data.list.forEach(item => {
            item.isSignUp = parseInt(item.isSignUp) // 是否报名: 0是 1未报名 2报名中 3报名失败
            item.isPush = item.isPush === 0
            item.startTime = item.startTime.replace(/-/g, '.')
            item.endTime = item.endTime.replace(/-/g, '.')
            item.startTime.length > 10 && (item.startTime = item.startTime.substring(0, 10))
            item.endTime.length > 10 && (item.endTime = item.endTime.substring(0, 10))
          })
          this.activityList = res.data.list
        }
      })
    },
    getAddress (val) {
      this.searchForm.provinceNo = val.provinceNo
      this.searchForm.cityNo = val.cityNo
    },
    querySearch (queryString, cb) {
      const result = []
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        if (queryString === '') {
          cb(result)
        } else {
          this.$axios.post(this.$api.activityFuzzySearch, {
            name: queryString
          }).then(res => {
            if (res.respCode === '0') {
              var result = res.data
              cb(result)
            } else {
              result = []
              cb(result)
            }
          })
        }
      }, 1000)
    }
  },
  mounted () {
    this.getList()
  },
  computed: {
    batchPlaceholder () {
      return this.confirmType === 'sign'
        ? '请输入参与活动报名的代理商编号，多个代理商请以英文逗号","隔开'
        : '请输入需要推送活动的代理商编号，多个代理商请以英文逗号","隔开'
    }
  }
}
</script>

<style lang="less" scoped>
.info {
  text-align: center;
  color: #333333;
  font-size: 16px;
}
.activity-item {
  margin: 12px;
  position: relative;
  /deep/ .el-card__header {
    // padding-left: 36px;
    padding: 12px;
  }
  /deep/ .el-card__body {
    padding-left: 24px;
  }
  .icon {
    width: 28px;
    height: 28px;
    padding-right: 10px;
  }
  .activity-title {
    font-size: 16px;
    font-weight: bold;
    color: #222222;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.activity-type {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  line-height: 24px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  border: 2px #1677FF solid;
  color: #1677FF;
  position: absolute;
  top: 4px;
  left: 4px;
}
.activity-body {
  font-size: 12px;
  line-height: 24px;
}
.activity-row {
  margin-bottom: 12px;
}
.activity-desc {
  display: inline-block;
  width: calc(100% - 70px);
  vertical-align: top;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  line-height: 24px;
  height: 72px;
  color: #666;
}
.activity-area {
  display: inline-block;
  width: calc(100% - 70px);
  vertical-align: top;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  line-height: 24px;
  height: 48px;
  color: #666;
}
.activity-value {
  color: #666;
}
.activity-label {
  width: 70px;
  display: inline-block;
}
.mark-btn {
  display: inline-block;
  cursor: pointer;
  border-radius: 2px;
  border: 1px solid #DFDFDF;
  width: 86px;
  line-height: 32px;
  text-align: center;
  height: 32px;
  color: #666;
  position: relative;
  &.active {
    border: 1px solid #1677ff;
    color: #1677ff;
    .mark {
      border-bottom-color: #1677ff;
      border-right-color: #1677ff;
    }
  }
  .mark {
    width: 0;
    height: 0;
    border: 12px solid #DFDFDF;
    border-top-color: transparent;
    border-left-color: transparent;
    position: absolute;
    right: 0;
    bottom: 0;
    i {
      position: absolute;
      font-size: 8px;
      color: #fff;
    }
  }
  &.disabled {
    cursor: not-allowed;
  }
}
.activity-action {
  // width: 220px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.activity-view {
  float: right;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: #C9C9C9;
  cursor: pointer;
  .arrow {
    margin-left: 6px;
    width: 12px;
    height: 12px;
  }
  .policy {
    font-size: 12px;
    color: #333333;
    width: 50px;
  }
}
.red {
  color: red;
}
.showConfirm {
  &.left {
    /deep/ .el-dialog__body {
      text-align: left !important;
    }
  }
  /deep/ .el-dialog__body {
    text-align: center;
    padding-top: 30px;
  }
  /deep/ .el-dialog__footer {
    text-align: center;
  }
}
.poster-outer {
  width: 720px;
  height: 1000px;
  background: #F5F5F5;
  position: relative;
}
.poster {
  &.outer {
    top: -2000px;
  }
  width: 3350px;
  // height: 540px;
  background: #FFFFFF;
  border-radius: 100px;
  text-align: left;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.15);
  .poster-bg {
    width: 3350px;
    height: 4200px;
  }
  .poster-title {
    font-size: 180px;
    font-weight: bold;
    color: #333;
    line-height: 200px;
    padding: 300px 0 140px 170px;
  }
  .poster-info {
    font-size: 120px;
    color: #000;
    padding: 0 170px 60px 170px;
    .poster-label {
      display: inline-block;
      width: 600px;
      font-size: 120px;
    }
    .poster-area {
      display: inline-block;
      width: calc(100% - 600px);
      vertical-align: top;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      font-size: 120px;
      line-height: 140px;
      height: 280px
    }
    &.time {
      margin-bottom: 200px;
    }
  }
  .qrcode {
    width: 950px;
    height: 950px;
    background: #FFFFFF;
    border: 10px solid #E4E6EF;
    border-radius: 120px;
    position: absolute;
    right: 150px;
    top: 3470px;
  }
}
.img_box {
  width: 800px;
  height: 800px;
  margin: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  /deep/ img {
    width: 800px;
    height: 800px;
  }
}
.link {
  padding: 0;
  width: 100px;
  margin-right:10px;
  text-align: left;
}
.add-info {
  font-size: 12px;
  margin-bottom: 12px;
}
.addResult {
  /deep/ .default {
    width: 600px !important;
  }
}
.dialog-header {
  font-size: 18px;
  color: #333;
}
.dialog-status {
  font-size: 16px;
  color: #333;
  &.success {
    color: #58AB58;
  }
  &.fail {
    color: red;
  }
}
</style>
